import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { isValid as reduxFormIsValid } from 'redux-form';

// Whether the whole form is valid. Inside a react-hook-form <FormProvider> it
// is that form's formState; otherwise it is the named redux-form's validity.
const useFormIsValid = (reduxFormName: string): boolean => {
  const form = useFormContext();
  const reduxFormValid = useSelector((state: any) =>
    reduxFormIsValid(reduxFormName)(state),
  );
  return form ? form.formState.isValid : reduxFormValid;
};

export default useFormIsValid;
